export default __webpack_public_path__ + "static/media/Eagle_new.ba6b1503.svg";